<div class="container" style="padding-left: 30px;">
  <h1 style="color: #002b5c; text-transform: none; padding-top: 20px;">Delivery settings</h1>
    <mat-form-field class="d-flex" appearance="fill" [formGroup]="dateForm" required>
      <mat-label>Select a Date</mat-label>
      <input matInput readonly [matDatepicker]="picker" formControlName="date">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <div *ngIf="!showShopClosedError">
    <dual-list [sort]="keepSorted" [(source)]="deliveryTimes" key="id" [display]="display" [filter]="filter"
    [(destination)]="confirmed" height="350px" [format]="format" [disabled]="disabled"
    (activeListChange)="setActiveList($event)"></dual-list>
  <button type="button" [disabled]="saving" class="btn btn-primary pull-right" style="margin-top: 20px;"
    (click)="save()">
    <div class="d-flex">
      <span style="padding-right: 10px">Save</span>
      <mat-spinner *ngIf="saving" [diameter]="15"></mat-spinner>
    </div>
  </button>
  <h3 *ngIf="successfullySaved" style="color: #002b5c;">Successfully updated time slots</h3>
  <h3 *ngIf="errorOnSave" style="color: #002b5c;">Failed to update time slots, contact admin</h3>
  </div>
  <h3 *ngIf="showShopClosedError" style="color: #002b5c;">Store is closed on this day of the week. Open the store for this day to edit the time slots.</h3>
</div>
<div class="update-fld-container" style="padding-left: 30px;">

  <div class="">
    <h1 style="color: #002b5c; text-transform: none; padding-bottom: 10px; margin-bottom: 0px;">Delivery Fee</h1>
    <div class="inner-field-container">
      <input type="text" name="deliveryFee" [(ngModel)]="deliveryFee">
      <button type="button" [disabled]="savingDelivery" class="btn btn-primary pull-right" style="margin: 0px 15px;"
      (click)="saveDeliveryFee()">
      <div class="d-flex">
        <span style="padding-right: 10px">Save</span>
        <mat-spinner *ngIf="savingDelivery" [diameter]="15"></mat-spinner>
      </div>
    </button>
    </div>
    <h3 *ngIf="successfullySavedDelivery"  class="val-msg" style="color: #002b5c;">Successfully updated delivery fee</h3>
    <h3 *ngIf="errorOnDeliverySave" class="val-msg" style="color: #002b5c;">Failed to update delivery fee, contact admin</h3>
  </div>

    <div style="margin-left: 30px;">
    <h1 style="color: #002b5c; text-transform: none; padding-bottom: 10px; margin-bottom: 0px;">ASAP Lead Time (Mins)</h1>
    <div class="inner-field-container">
      <input type="text" name="deliveryLeadTime" [(ngModel)]="deliveryLeadTime">
      <button type="button" [disabled]="savingLeadTime" class="btn btn-primary pull-right" style="margin: 0px 15px;"
      (click)="saveLeadTime()">
      <div class="d-flex">
        <span style="padding-right: 10px;">Save</span>
        <mat-spinner *ngIf="savingLeadTime" [diameter]="15"></mat-spinner>
      </div>
    </button>
    </div>
    <h3 *ngIf="successfullySavedLeadTime" class="val-msg" style="color: #002b5c;">Successfully updated delivery lead time</h3>
    <h3 *ngIf="errorOnLeadTimeSave" class="val-msg" style="color: #002b5c;">Failed to update delivery lead time, contact admin</h3>
</div>

</div>